import api from './axiosInstance';
import i18n from '../i18n';

export const getClicks = async (userId, startDate, endDate) => {
    try {
        const response = await api.post(`/clicks/${userId}`, { startDate, endDate });
        return response.data;
    } catch (error) {
        console.error('Error fetching clicks:', error);
        throw new Error(i18n.t('clickService.fetch_clicks_error'));
    }
};

export const deleteClicks = async (userId, clickIds) => {
    try {
        const response = await api.post(`/delete-clicks/${userId}`, { clickIds });
        return response.data;
    } catch (error) {
        console.error('Error deleting clicks:', error);
        throw new Error(i18n.t('clickService.delete_clicks_error'));
    }
};

export const blockIP = async (ip, userId) => {
    try {
        const response = await api.post('/block-ip', { ip, userId });
        return response.data;
    } catch (error) {
        console.error('Error blocking IP:', error);
        throw new Error(i18n.t('clickService.block_ip_error'));
    }
};

export const unblockIP = async (ip, userId) => {
    try {
        const response = await api.post('/unblock-ip', { ip, userId });
        return response.data;
    } catch (error) {
        console.error('Error unblocking IP:', error);
        throw new Error(i18n.t('clickService.unblock_ip_error'));
    }
};

export const getBlockedIPs = async (userId) => {
    try {
        const response = await api.get(`/blocked-ips/${userId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching blocked IPs:', error);
        throw new Error(i18n.t('clickService.get_blocked_ips_error'));
    }
};

export const getAllBlockedIPs = async () => {
    try {
        const response = await api.get('/blocked-ips');
        return response.data;
    } catch (error) {
        console.error('Error fetching all blocked IPs:', error);
        throw new Error(i18n.t('clickService.get_all_blocked_ips_error'));
    }
};